/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления баннерами.
 * Используются как источник Критичнх уведомления, White label компаний и объявления рекламных акций
 */

/**
 * Сервис управления баннерами
 */
export class BannerServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения баннера.
   * Поддерживает создание и обновление.
   * Метод доступен для: admin, manager, service
   */
  PostBanner = (req: PostBannerRequestDto, init?: RequestInit): Promise<PostBannerResponseDto> => {
    return fm.request<PostBannerRequestDto, PostBannerResponseDto>(`${this.host}/banner/api/v1/banner`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения баннера.
   * Метод доступен для: admin, manager, service
   */
  GetBanner = (req: GetBannerRequestDto, init?: RequestInit): Promise<GetBannerResponseDto> => {
    return fm.request<GetBannerRequestDto, GetBannerResponseDto>(`${this.host}/banner/api/v1/banner/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения упрощённого баннера.
   * Не требует авторизации
   */
  GetBannerLite = (req: GetBannerLiteRequestDto, init?: RequestInit): Promise<GetBannerLiteResponseDto> => {
    return fm.request<GetBannerLiteRequestDto, GetBannerLiteResponseDto>(`${this.host}/banner/api/v1/banner_lite/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка баннеров.
   * Метод доступен для: admin, manager, service
   */
  GetBannerList = (req?: GetBannerListRequestDto, init?: RequestInit): Promise<GetBannerListResponseDto[]> => {
    return fm.list<GetBannerListRequestDto, GetBannerListResponseDto>(`${this.host}/banner/api/v1/banner/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения списка упрощённых баннеров.
   * Возвращает всегда активные баннеры.
   * По умолчанию возвращает первые 20 баннеров осортированных по приоритету, затем по дате начала акции(от самых важных к не важным, затем от самых новых акций к самым старым).
   * Если запрос выполнен хотя бы без одного изпризнака приложения возвращает пустой список.
   * Если запрос выполнен без признаков пользователя метод возвращает пустой список.
   * Не требует авторизации
   */
  GetBannerLiteList = (req?: GetBannerLiteListRequestDto, init?: RequestInit): Promise<GetBannerLiteListResponseDto[]> => {
    return fm.list<GetBannerLiteListRequestDto, GetBannerLiteListResponseDto>(`${this.host}/banner/api/v1/banner_lite/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества баннеров.
   * Метод доступен для: admin, manager, service
   */
  GetBannerCount = (req?: GetBannerCountRequestDto, init?: RequestInit): Promise<GetBannerCountResponseDto> => {
    return fm.request<GetBannerCountRequestDto, GetBannerCountResponseDto>(`${this.host}/banner/api/v1/banner/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод загрузки картинки баннера.
   * Метод доступен для: admin, manager, service
   */
  PostBannerUploadImage = (req: PostBannerUploadImageRequestDto, init?: RequestInit): Promise<PostBannerUploadImageResponseDto> => {
    return fm.request<UploadImageRequestDto, PostBannerUploadImageResponseDto>(`${this.host}/banner/api/v1/banner/${encodeURIComponent(req.bannerId)}/upload_image`, { ...init, method: "POST", body: JSON.stringify(req.uploadImage, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов картинок.
 */
export enum BannerImageType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Пререндеренный баннер в портретном режиме.
   * В портретном режиме ширина меньше или равна высоте.
   * Представление характерно для телефонов.
   * Может содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).
   * После загрузки изображения отрисовывается поверх цвета и градиента.
   * Если ссылки нет то нужно использовать ссылку из ландшафтного режима
   */
  PORTRAIT = "PORTRAIT",
  /**
   * Пререндеренный баннер в ландшафтном режиме.
   * В ландшафтном режиме ширина больше высоты.
   * Представление характерно для планшетов и декстопа.
   * Может содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).
   * После загрузки изображения отрисовывается поверх цвета и градиента.
   * Если ссылки нет то нужно использовать ссылку из портретного режима
   */
  LANDSCAPE = "LANDSCAPE",
  /**
   * Иконка.
   * Может содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).
   * После загрузки изображения отрисовывается поверх цвета и градиента
   */
  ICON = "ICON",
}
/**
 * Справочник типов картинок.
 */
export type BannerImageTypeResponseEnum = keyof typeof BannerImageType
/**
 * Справочник типов картинок.
 */
export type BannerImageTypeRequestEnum = Exclude<BannerImageTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов ссылок.
 */
export enum BannerLinkType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Ссылка для перехода на раздел текущего приложения
   */
  INTERNAL_APP = "INTERNAL_APP",
  /**
   * Ссылка для перехода на стороннее приложение
   */
  EXTERNAL_APP = "EXTERNAL_APP",
  /**
   * Ссылка для перехода на веб-вью внутренних (своих) приложений.
   * В окне отсутствует адресаная строка.
   * Для iOS используется WKWebView, для Android используется WebView
   */
  WEB_VIEW = "WEB_VIEW",
  /**
   * Ссылка для перехода на веб-браузер
   */
  WEB_BROWSER = "WEB_BROWSER",
  /**
   * Ссылка для перехода на веб-вью внешних (партнёрских) приложений.
   * В окне присутствует адресаная строка.
   * Для iOS используется SFSafariViewController, для Android используется ChromeCustomTabs
   */
  EXTERNAL_WEB_VIEW = "EXTERNAL_WEB_VIEW",
}
/**
 * Справочник типов ссылок.
 */
export type BannerLinkTypeResponseEnum = keyof typeof BannerLinkType
/**
 * Справочник типов ссылок.
 */
export type BannerLinkTypeRequestEnum = Exclude<BannerLinkTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник платформ.
 */
export enum BannerPlatformType {
  /**
   * Значение не указано
   */
  PLATFORM_TYPE_UNKNOWN = "PLATFORM_TYPE_UNKNOWN",
  /**
   * Платформа iOS.
   * Приложение размещается в App Store
   */
  IOS = "IOS",
  /**
   * Платформа Android.
   * Приложение размещается в Google Play, App Gallery или прочих сторах
   */
  ANDROID = "ANDROID",
  /**
   * Платформа Web.
   * Приложение размещается по интернет адресу
   */
  WEB = "WEB",
}
/**
 * Справочник платформ.
 */
export type BannerPlatformTypeResponseEnum = keyof typeof BannerPlatformType
/**
 * Справочник платформ.
 */
export type BannerPlatformTypeRequestEnum = Exclude<BannerPlatformTypeResponseEnum, "PLATFORM_TYPE_UNKNOWN">;

/**
 * Справочник типов приоритетов.
 */
export enum BannerPriorityType {
  /**
   * Значение не указано
   */
  PRIORITY_TYPE_UNKNOWN = "PRIORITY_TYPE_UNKNOWN",
  /**
   * Обычный.
   * Приоритет 31.
   * Вычисляется в логике приложения как priority меньше 64.
   * Извлекаются из базы по фильтру end_priority = 64
   */
  NORMAL = "NORMAL",
  /**
   * Вайт-лейбл.
   * Приоритет 127.
   * Вычисляется в логике приложения как priority больше или равно 64 и priority меньше 160.
   * Извлекаются из базы по фильтру begin_priority = 64 и end_priority = 160
   */
  WHITE_LABEL = "WHITE_LABEL",
  /**
   * Критикл.
   * Приоритет 191.
   * Вычисляется в логике приложения как priority больше или равно 160.
   * Извлекаются из базы по фильтру begin_priority = 160
   */
  CRITICAL = "CRITICAL",
}
/**
 * Справочник типов приоритетов.
 */
export type BannerPriorityTypeResponseEnum = keyof typeof BannerPriorityType
/**
 * Справочник типов приоритетов.
 */
export type BannerPriorityTypeRequestEnum = Exclude<BannerPriorityTypeResponseEnum, "PRIORITY_TYPE_UNKNOWN">;

/**
 * Справочник статусов баннеров.
 */
export enum BannerStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Отложен.
   * Вычисляется в логике приложения как сurr_date меньше show_start_at.
   * Извлекаются из базы по фильтру end_show_start_at = сurr_date
   */
  DEFERRED = "DEFERRED",
  /**
   * Активен.
   * Вычисляется в логике приложения как сurr_date больше или равно show_start_at и сurr_date меньше show_ended_at.
   * Извлекаются из базы по фильтру begin_show_start_at = сurr_date и end_show_ended_at = сurr_date
   */
  ACTIVE = "ACTIVE",
  /**
   * Истёк.
   * Вычисляется в логике приложения как сurr_date больше или равно show_ended_at.
   * Извлекаются из базы по фильтру begin_show_ended_at = сurr_date
   */
  EXPIRED = "EXPIRED",
}
/**
 * Справочник статусов баннеров.
 */
export type BannerStatusTypeResponseEnum = keyof typeof BannerStatusType
/**
 * Справочник статусов баннеров.
 */
export type BannerStatusTypeRequestEnum = Exclude<BannerStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов баннеров.
 */
export enum BannerType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Стандартный баннер
   */
  STANDARD = "STANDARD",
}
/**
 * Справочник типов баннеров.
 */
export type BannerTypeResponseEnum = keyof typeof BannerType
/**
 * Справочник типов баннеров.
 */
export type BannerTypeRequestEnum = Exclude<BannerTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum BannerPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type BannerPagingDirectionTypeResponseEnum = keyof typeof BannerPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type BannerPagingDirectionTypeRequestEnum = Exclude<BannerPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum BannerPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * По приоритету, затем по дате начала показа
   */
  PRIORITY_THEN_SHOW_START_AT = "PRIORITY_THEN_SHOW_START_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * Дата начала показа
   */
  SHOW_START_AT = "SHOW_START_AT",
  /**
   * Дата конца показа
   */
  SHOW_ENDED_AT = "SHOW_ENDED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type BannerPagingOrderByTypeResponseEnum = keyof typeof BannerPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type BannerPagingOrderByTypeRequestEnum = Exclude<BannerPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Баннер.
 * # Описание модели
 */
export type BannerRequestDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id?: string
  /**
   * Тип баннера.
   * Обязательное
   */
  type: BannerTypeRequestEnum
  /**
   * Приоритет.
   * Обязательное.
   * # Диапазон: 1..255
   */
  priority: number
  /**
   * Название.
   * Обязательное.
   * Обычно это название рекламной компании.
   * Не отображается пользователям.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Заголовок.
   * # Диапазон: 3..64
   */
  header?: string | null
  /**
   * Цвет текста заголовка.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  headerColor?: string | null
  /**
   * Подзаголовок.
   * # Диапазон: 3..256
   */
  subtitle?: string | null
  /**
   * Цвет текста подзаголовка.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  subtitleColor?: string | null
  /**
   * Цвет заднего плана(подложки).
   * Отрисовывается до загрузки картинки и градиента.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  backgroundColor?: string | null
  /**
   * Градиент
   */
  backgroundGradient?: BannerGradientRequestDto | null
  /**
   * Количество дней через которое можно повторно показать баннер.
   * Если null, то закрыть нельзя, баннер повторно выводится каждый раз.
   * # Диапазон: 0..366
   */
  repeatAfterDays?: number | null
  /**
   * Дата начала показа.
   * Обязательное.
   * Бессрочно если значение 2000-01-01.
   * # Тип: DateOnly.
   * # Диапазон: 730119..1095362
   */
  showStartAt: string
  /**
   * Дата конца показа.
   * Обязательное.
   * Бессрочно если значение 3000-01-01.
   * # Тип: DateOnly.
   * # Диапазон: 730119..1095362
   */
  showEndedAt: string
  /**
   * Картинки.
   * # Диапазон: 0..20
   */
  images?: BannerImageRequestDto[]
  /**
   * Ссылки для переходов.
   * # Диапазон: 0..100
   */
  links?: BannerLinkRequestDto[]
  /**
   * Список тегов пользователей.
   * Обязательное.
   * Описывает кто может видеть баннер.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..100.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
  /**
   * Список тегов приложений.
   * Обязательное.
   * Описывает какие клиенты могут видеть баннер.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags: string[]
}
/**
 * Баннер.
 * # Описание модели
 */
export type BannerResponseDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id: string
  /**
   * Тип баннера.
   * Обязательное
   */
  type: BannerTypeResponseEnum
  /**
   * Приоритет.
   * Обязательное.
   * # Диапазон: 1..255
   */
  priority: number
  /**
   * Тип приоритета.
   * # Поле вычисляется в коде приложения
   */
  readonly priorityType: BannerPriorityTypeResponseEnum
  /**
   * Название.
   * Обязательное.
   * Обычно это название рекламной компании.
   * Не отображается пользователям.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Заголовок.
   * # Диапазон: 3..64
   */
  header: string | null
  /**
   * Цвет текста заголовка.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  headerColor: string | null
  /**
   * Подзаголовок.
   * # Диапазон: 3..256
   */
  subtitle: string | null
  /**
   * Цвет текста подзаголовка.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  subtitleColor: string | null
  /**
   * Цвет заднего плана(подложки).
   * Отрисовывается до загрузки картинки и градиента.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  backgroundColor: string | null
  /**
   * Градиент
   */
  backgroundGradient: BannerGradientResponseDto | null
  /**
   * Количество дней через которое можно повторно показать баннер.
   * Если null, то закрыть нельзя, баннер повторно выводится каждый раз.
   * # Диапазон: 0..366
   */
  repeatAfterDays: number | null
  /**
   * Дата начала показа.
   * Обязательное.
   * Бессрочно если значение 2000-01-01.
   * # Тип: DateOnly.
   * # Диапазон: 730119..1095362
   */
  showStartAt: string
  /**
   * Дата конца показа.
   * Обязательное.
   * Бессрочно если значение 3000-01-01.
   * # Тип: DateOnly.
   * # Диапазон: 730119..1095362
   */
  showEndedAt: string
  /**
   * Статус баннера.
   * # Поле вычисляется в коде приложения
   */
  readonly statusType: BannerStatusTypeResponseEnum
  /**
   * Картинки.
   * # Диапазон: 0..20
   */
  images: BannerImageResponseDto[]
  /**
   * Ссылки для переходов.
   * # Диапазон: 0..100
   */
  links: BannerLinkResponseDto[]
  /**
   * Список тегов пользователей.
   * Обязательное.
   * Описывает кто может видеть баннер.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..100.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
  /**
   * Список тегов приложений.
   * Обязательное.
   * Описывает какие клиенты могут видеть баннер.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags: string[]
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
}
/**
 * Градиент
 */
export type BannerGradientRequestDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Линейный градиент
   */
  readonly linear: BannerGradientLinearRequestDto
}>
/**
 * Градиент
 */
export type BannerGradientResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Линейный градиент
   */
  readonly linear: BannerGradientLinearResponseDto
}>
/**
 * Линейный градиент
 */
export type BannerGradientLinearRequestDto = {
  /**
   * Угол направления линейного градиента в градусах.
   * # Диапазон: 0..360
   */
  angle?: number
  /**
   * Точки градиента.
   * Обязательное.
   * # Диапазон: 2..20
   */
  points: BannerGradientLinearPointRequestDto[]
}
/**
 * Линейный градиент
 */
export type BannerGradientLinearResponseDto = {
  /**
   * Угол направления линейного градиента в градусах.
   * # Диапазон: 0..360
   */
  angle: number
  /**
   * Точки градиента.
   * Обязательное.
   * # Диапазон: 2..20
   */
  points: BannerGradientLinearPointResponseDto[]
}
/**
 * Точка
 */
export type BannerGradientLinearPointRequestDto = {
  /**
   * Цвет линейного градиента.
   * Обязательное.
   * Отрисовывается до загрузки картинки и градиента.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  color: string
  /**
   * Стоп линейного градиента.
   * Записывается в процентах.
   * # Диапазон: 0..100
   */
  stop?: number
}
/**
 * Точка
 */
export type BannerGradientLinearPointResponseDto = {
  /**
   * Цвет линейного градиента.
   * Обязательное.
   * Отрисовывается до загрузки картинки и градиента.
   * Все цвета должны быть в формате hex #RRGGBBAA.
   * Пример: #7e00c380.
   * # Диапазон: 9..9.
   * # Паттерн: /^#[0-9a-fA-F]{8}$/
   */
  color: string
  /**
   * Стоп линейного градиента.
   * Записывается в процентах.
   * # Диапазон: 0..100
   */
  stop: number
}
/**
 * Объект картинки
 */
export type BannerImageRequestDto = {
  /**
   * Тип картинки.
   * Обязательное
   */
  type: BannerImageTypeRequestEnum
  /**
   * Значение ссылки на картинку.
   * Обязательное.
   * # Диапазон: 12..512
   */
  url: string
}
/**
 * Объект картинки
 */
export type BannerImageResponseDto = {
  /**
   * Тип картинки.
   * Обязательное
   */
  type: BannerImageTypeResponseEnum
  /**
   * Значение ссылки на картинку.
   * Обязательное.
   * # Диапазон: 12..512
   */
  url: string
}
/**
 * Ссылка
 */
export type BannerLinkRequestDto = {
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: BannerPlatformTypeRequestEnum
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: BannerLinkTypeRequestEnum
  /**
   * Значение ссылки для перехода.
   * Обязательное.
   * # Диапазон: 12..512
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.
   * # Диапазон: 0..20
   */
  packages?: string[]
}
/**
 * Ссылка
 */
export type BannerLinkResponseDto = {
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: BannerPlatformTypeResponseEnum
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: BannerLinkTypeResponseEnum
  /**
   * Значение ссылки для перехода.
   * Обязательное.
   * # Диапазон: 12..512
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.
   * # Диапазон: 0..20
   */
  packages: string[]
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type BannerSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: BannerSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type BannerSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: BannerSavingErrorConflictResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type BannerSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type BannerSavingErrorConflictResponseDto = {
}
/**
 * Фильтр баннеров
 */
export type BannerFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Название;
   * # - Заголовок;
   * # - Подзаголовок;
   * # - Список тегов пользователей;
   * # - Список тегов приложений
   */
  text?: string | null
  /**
   * По типам баннеров
   */
  types?: BannerTypeResponseEnum[]
  /**
   * От приоритета включительно (больше или равно)
   */
  beginPriority?: number | null
  /**
   * До приоритета (меньше)
   */
  endPriority?: number | null
  /**
   * По типам приоритетов.
   * Переписывает значения фильтров по приоритету.
   * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
   */
  priorityTypes?: BannerPriorityTypeResponseEnum[]
  /**
   * От даты начала показа включительно (больше или равно)
   */
  beginShowStartAt?: string | null
  /**
   * До даты начала показа (меньше)
   */
  endShowStartAt?: string | null
  /**
   * От даты конца показа включительно (больше или равно)
   */
  beginShowEndedAt?: string | null
  /**
   * До даты конца показа (меньше)
   */
  endShowEndedAt?: string | null
  /**
   * По статусам баннеров.
   * Переписывает значения фильтров по датам.
   * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
   */
  statusTypes?: BannerStatusTypeResponseEnum[]
  /**
   * По пользовательским тегам.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags?: string[]
  /**
   * По тегам приложений.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags?: string[]
}
/**
 * Фильтр баннеров
 */
export type BannerFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Название;
   * # - Заголовок;
   * # - Подзаголовок;
   * # - Список тегов пользователей;
   * # - Список тегов приложений
   */
  text: string | null
  /**
   * По типам баннеров
   */
  types: BannerTypeResponseEnum[]
  /**
   * От приоритета включительно (больше или равно)
   */
  beginPriority: number | null
  /**
   * До приоритета (меньше)
   */
  endPriority: number | null
  /**
   * По типам приоритетов.
   * Переписывает значения фильтров по приоритету.
   * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
   */
  priorityTypes: BannerPriorityTypeResponseEnum[]
  /**
   * От даты начала показа включительно (больше или равно)
   */
  beginShowStartAt: string | null
  /**
   * До даты начала показа (меньше)
   */
  endShowStartAt: string | null
  /**
   * От даты конца показа включительно (больше или равно)
   */
  beginShowEndedAt: string | null
  /**
   * До даты конца показа (меньше)
   */
  endShowEndedAt: string | null
  /**
   * По статусам баннеров.
   * Переписывает значения фильтров по датам.
   * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
   */
  statusTypes: BannerStatusTypeResponseEnum[]
  /**
   * По пользовательским тегам.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
  /**
   * По тегам приложений.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 0..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  appTags: string[]
}
/**
 * Облегчённый баннер
 */
export type BannerLiteRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id?: string
  /**
   * Количество дней через которое можно повторно показать баннер.
   * Если Значение не указано то повторного показа баннера не будет
   */
  repeatAfterDays?: number | null
  /**
   * Картинки
   */
  images?: BannerLiteImageLiteRequestDto[]
  /**
   * Ссылки для переходов.
   * Возвращаются отфильтрованные по платформе
   */
  links?: BannerLiteLinkLiteRequestDto[]
}
/**
 * Облегчённый баннер
 */
export type BannerLiteResponseDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
  /**
   * Количество дней через которое можно повторно показать баннер.
   * Если Значение не указано то повторного показа баннера не будет
   */
  repeatAfterDays: number | null
  /**
   * Картинки
   */
  images: BannerLiteImageLiteResponseDto[]
  /**
   * Ссылки для переходов.
   * Возвращаются отфильтрованные по платформе
   */
  links: BannerLiteLinkLiteResponseDto[]
}
/**
 * Упрощённый объект картинки
 */
export type BannerLiteImageLiteRequestDto = {
  /**
   * Тип картинки.
   * Обязательное
   */
  type: BannerImageTypeRequestEnum
  /**
   * Значение ссылки на картинку.
   * Обязательное
   */
  url: string
}
/**
 * Упрощённый объект картинки
 */
export type BannerLiteImageLiteResponseDto = {
  /**
   * Тип картинки.
   * Обязательное
   */
  type: BannerImageTypeResponseEnum
  /**
   * Значение ссылки на картинку.
   * Обязательное
   */
  url: string
}
/**
 * Упрощённая ссылка
 */
export type BannerLiteLinkLiteRequestDto = {
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: BannerLinkTypeRequestEnum
  /**
   * Значение ссылки.
   * Обязательное
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве иначе обработка переходит к следующей ссылке
   */
  packages?: string[]
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: BannerPlatformTypeRequestEnum
}
/**
 * Упрощённая ссылка
 */
export type BannerLiteLinkLiteResponseDto = {
  /**
   * Тип ссылки.
   * Обязательное
   */
  type: BannerLinkTypeResponseEnum
  /**
   * Значение ссылки.
   * Обязательное
   */
  url: string
  /**
   * Список пакетов.
   * Если пусто попытка перехода осуществляется безусловно.
   * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве иначе обработка переходит к следующей ссылке
   */
  packages: string[]
  /**
   * Тип платформы.
   * Обязательное
   */
  platformType: BannerPlatformTypeResponseEnum
}
/**
 * Упрощённый фильтр по баннерам
 */
export type BannerLiteFilterRequestDto = {
  /**
   * По типам баннеров
   */
  types?: BannerTypeResponseEnum[]
  /**
   * Название приложения.
   * # Диапазон: 1..19.
   * # Паттерн: /^[0-9A-Z-]{1,19}$/
   */
  appName?: string | null
  /**
   * Тип платформы
   */
  platformType?: BannerPlatformTypeResponseEnum
  /**
   * Версия приложения.
   * # Диапазон: 1..19.
   * # Паттерн: /^[0-9A-Z-]{1,19}$/
   */
  version?: string | null
  /**
   * По тегам пользователя.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags?: string[]
}
/**
 * Упрощённый фильтр по баннерам
 */
export type BannerLiteFilterResponseDto = {
  /**
   * По типам баннеров
   */
  types: BannerTypeResponseEnum[]
  /**
   * Название приложения.
   * # Диапазон: 1..19.
   * # Паттерн: /^[0-9A-Z-]{1,19}$/
   */
  appName: string | null
  /**
   * Тип платформы
   */
  platformType: BannerPlatformTypeResponseEnum
  /**
   * Версия приложения.
   * # Диапазон: 1..19.
   * # Паттерн: /^[0-9A-Z-]{1,19}$/
   */
  version: string | null
  /**
   * По тегам пользователя.
   * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
   * # Диапазон: 1..20.
   * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
   */
  userTags: string[]
}
/**
 * Пагинация баннеров
 */
export type BannerPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: BannerPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: BannerPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация баннеров
 */
export type BannerPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: BannerPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: BannerPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос получения количества баннеров
 */
export type GetBannerCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: BannerFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества баннеров
 */
export type GetBannerCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего баннеров
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetBannerCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества баннеров
 */
export type GetBannerCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества баннеров
 */
export type GetBannerCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка баннеров
 */
export type GetBannerListRequestDto = {
  /**
   * Фильтр
   */
  filter?: BannerFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: BannerPagingRequestDto
}>
/**
 * Ответ на запрос получения списка баннеров
 */
export type GetBannerListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Баннер
   */
  readonly data: BannerResponseDto
  /**
   * Ошибка
   */
  readonly error: GetBannerListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка баннеров
 */
export type GetBannerListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка баннеров
 */
export type GetBannerListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка упрощённого баннеров
 */
export type GetBannerLiteListRequestDto = {
  /**
   * Упрощённый фильтр
   */
  filter?: BannerLiteFilterRequestDto | null
  /**
   * Признак отключения фильтрации по типу платформы
   */
  isLinkFilterDisabled?: boolean
}
/**
 * Ответ на запрос получения списка упрощённых баннеров
 */
export type GetBannerLiteListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Упрощённый баннер
   */
  readonly data: BannerLiteResponseDto
  /**
   * Ошибка
   */
  readonly error: GetBannerLiteListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка баннеров
 */
export type GetBannerLiteListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка баннеров
 */
export type GetBannerLiteListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения упрощённого баннера
 */
export type GetBannerLiteRequestDto = {
  /**
   * Идентификатор баннера.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения упрощённого баннера
 */
export type GetBannerLiteResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Упрощённый баннер
   */
  readonly data: BannerLiteResponseDto
  /**
   * Ошибка
   */
  readonly error: GetBannerLiteResponseErrorDto
}>
/**
 * Ошибка запроса получения упрощённого баннера
 */
export type GetBannerLiteResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения упрощённого баннера
 */
export type GetBannerLiteResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения баннера
 */
export type GetBannerRequestDto = {
  /**
   * Идентификатор баннера.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения баннера
 */
export type GetBannerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Баннер
   */
  readonly data: BannerResponseDto
  /**
   * Ошибка
   */
  readonly error: GetBannerResponseErrorDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetBannerResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetBannerResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос сохранения баннера
 */
export type PostBannerRequestDto = {
  /**
   * Баннер
   */
  data: BannerRequestDto
}
/**
 * Ответ на запрос сохранения баннера
 */
export type PostBannerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Баннер
   */
  readonly data: BannerResponseDto
  /**
   * Ошибка
   */
  readonly error: PostBannerResponseErrorDto
}>
/**
 * Ошибка запроса сохранения баннера
 */
export type PostBannerResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: BannerSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения баннера
 */
export type PostBannerResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: BannerSavingErrorResponseDto
}>
/**
 * Запрос загрузки картинки баннера
 */
export type PostBannerUploadImageRequestDto = {
  /**
   * Идентификатор баннера.
   * Используется для складывания картинок баннера в папку баннера в бакете.
   * Название картинки в папке создаётся из случайного Guid.
   * # Тип: Guid
   */
  bannerId: string
  /**
   * Загружаемая картинка
   */
  uploadImage: UploadImageRequestDto
}
/**
 * Ответ на запрос загрузки картинки баннера
 */
export type PostBannerUploadImageResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ссылка на баннер на imageproxy cdn сервер.
   * Общедоступна в интернете
   */
  readonly data: string
  /**
   * Ошибка
   */
  readonly error: PostBannerUploadImageResponseErrorDto
}>
/**
 * Ошибка запроса загрузки картинки баннера
 */
export type PostBannerUploadImageResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса загрузки картинки баннера
 */
export type PostBannerUploadImageResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Объект загружаемой картинки
 */
export type UploadImageRequestDto = {
  /**
   * Картинка в формате инлайн base64.
   * Обязательное.
   * Пример: \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIA...\".
   * # Паттерн: /^data:\s*image\/(png|jpeg|jpg);\s*base64/
   */
  base64: string
}
/**
 * Объект загружаемой картинки
 */
export type UploadImageResponseDto = {
  /**
   * Картинка в формате инлайн base64.
   * Обязательное.
   * Пример: \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIA...\".
   * # Паттерн: /^data:\s*image\/(png|jpeg|jpg);\s*base64/
   */
  base64: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Баннер.
   * # Описание модели
   */
  "Banner": {
    "kind": "class",
    "text": "Баннер.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * Если не передан создаётся сервером.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nЕсли не передан создаётся сервером.\n# Тип: Guid",
      },
      /**
       * Тип баннера.
       * Обязательное
       */
      "type": {
        "type": "Banner.Type",
        "text": "Тип баннера.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Приоритет.
       * Обязательное.
       * # Диапазон: 1..255
       */
      "priority": {
        "type": "int32",
        "text": "Приоритет.\nОбязательное.\n# Диапазон: 1..255",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 255,
            "message": "Значение не входит в допустимый диапазон. Максимум: 255"
          },
        }
      },
      /**
       * Тип приоритета.
       * # Поле вычисляется в коде приложения
       */
      "priorityType": {
        "type": "Banner.PriorityType",
        "text": "Тип приоритета.\n# Поле вычисляется в коде приложения",
      },
      /**
       * Название.
       * Обязательное.
       * Обычно это название рекламной компании.
       * Не отображается пользователям.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Название.\nОбязательное.\nОбычно это название рекламной компании.\nНе отображается пользователям.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Заголовок.
       * # Диапазон: 3..64
       */
      "header": {
        "type": "google.protobuf.StringValue",
        "text": "Заголовок.\n# Диапазон: 3..64",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Цвет текста заголовка.
       * Все цвета должны быть в формате hex #RRGGBBAA.
       * Пример: #7e00c380.
       * # Диапазон: 9..9.
       * # Паттерн: /^#[0-9a-fA-F]{8}$/
       */
      "headerColor": {
        "type": "google.protobuf.StringValue",
        "text": "Цвет текста заголовка.\nВсе цвета должны быть в формате hex #RRGGBBAA.\nПример: #7e00c380.\n# Диапазон: 9..9.\n# Паттерн: /^#[0-9a-fA-F]{8}$/",
        "rules": {
          "minLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Минимум: 9"
          },
          "maxLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9"
          },
          "pattern": {
            "value": /^#[0-9a-fA-F]{8}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^#[0-9a-fA-F]{8}$/"
          }
        }
      },
      /**
       * Подзаголовок.
       * # Диапазон: 3..256
       */
      "subtitle": {
        "type": "google.protobuf.StringValue",
        "text": "Подзаголовок.\n# Диапазон: 3..256",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Цвет текста подзаголовка.
       * Все цвета должны быть в формате hex #RRGGBBAA.
       * Пример: #7e00c380.
       * # Диапазон: 9..9.
       * # Паттерн: /^#[0-9a-fA-F]{8}$/
       */
      "subtitleColor": {
        "type": "google.protobuf.StringValue",
        "text": "Цвет текста подзаголовка.\nВсе цвета должны быть в формате hex #RRGGBBAA.\nПример: #7e00c380.\n# Диапазон: 9..9.\n# Паттерн: /^#[0-9a-fA-F]{8}$/",
        "rules": {
          "minLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Минимум: 9"
          },
          "maxLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9"
          },
          "pattern": {
            "value": /^#[0-9a-fA-F]{8}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^#[0-9a-fA-F]{8}$/"
          }
        }
      },
      /**
       * Цвет заднего плана(подложки).
       * Отрисовывается до загрузки картинки и градиента.
       * Все цвета должны быть в формате hex #RRGGBBAA.
       * Пример: #7e00c380.
       * # Диапазон: 9..9.
       * # Паттерн: /^#[0-9a-fA-F]{8}$/
       */
      "backgroundColor": {
        "type": "google.protobuf.StringValue",
        "text": "Цвет заднего плана(подложки).\nОтрисовывается до загрузки картинки и градиента.\nВсе цвета должны быть в формате hex #RRGGBBAA.\nПример: #7e00c380.\n# Диапазон: 9..9.\n# Паттерн: /^#[0-9a-fA-F]{8}$/",
        "rules": {
          "minLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Минимум: 9"
          },
          "maxLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9"
          },
          "pattern": {
            "value": /^#[0-9a-fA-F]{8}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^#[0-9a-fA-F]{8}$/"
          }
        }
      },
      /**
       * Градиент
       */
      "backgroundGradient": {
        "type": "Banner.Gradient",
        "text": "Градиент",
      },
      /**
       * Количество дней через которое можно повторно показать баннер.
       * Если null, то закрыть нельзя, баннер повторно выводится каждый раз.
       * # Диапазон: 0..366
       */
      "repeatAfterDays": {
        "type": "google.protobuf.Int32Value",
        "text": "Количество дней через которое можно повторно показать баннер.\nЕсли null, то закрыть нельзя, баннер повторно выводится каждый раз.\n# Диапазон: 0..366",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 366,
            "message": "Значение не входит в допустимый диапазон. Максимум: 366"
          },
        }
      },
      /**
       * Дата начала показа.
       * Обязательное.
       * Бессрочно если значение 2000-01-01.
       * # Тип: DateOnly.
       * # Диапазон: 730119..1095362
       */
      "showStartAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата начала показа.\nОбязательное.\nБессрочно если значение 2000-01-01.\n# Тип: DateOnly.\n# Диапазон: 730119..1095362",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 730119,
            "message": "Значение не входит в допустимый диапазон. Минимум: 730119"
          },
          "max": {
            "value": 1095362,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1095362"
          },
        }
      },
      /**
       * Дата конца показа.
       * Обязательное.
       * Бессрочно если значение 3000-01-01.
       * # Тип: DateOnly.
       * # Диапазон: 730119..1095362
       */
      "showEndedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата конца показа.\nОбязательное.\nБессрочно если значение 3000-01-01.\n# Тип: DateOnly.\n# Диапазон: 730119..1095362",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 730119,
            "message": "Значение не входит в допустимый диапазон. Минимум: 730119"
          },
          "max": {
            "value": 1095362,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1095362"
          },
        }
      },
      /**
       * Статус баннера.
       * # Поле вычисляется в коде приложения
       */
      "statusType": {
        "type": "Banner.StatusType",
        "text": "Статус баннера.\n# Поле вычисляется в коде приложения",
      },
      /**
       * Картинки.
       * # Диапазон: 0..20
       */
      "images": {
        "type": "Banner.Image",
        "text": "Картинки.\n# Диапазон: 0..20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
        }
      },
      /**
       * Ссылки для переходов.
       * # Диапазон: 0..100
       */
      "links": {
        "type": "Banner.Link",
        "text": "Ссылки для переходов.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Список тегов пользователей.
       * Обязательное.
       * Описывает кто может видеть баннер.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 1..100.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "userTags": {
        "type": "string",
        "text": "Список тегов пользователей.\nОбязательное.\nОписывает кто может видеть баннер.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 1..100.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
      /**
       * Список тегов приложений.
       * Обязательное.
       * Описывает какие клиенты могут видеть баннер.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 1..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "appTags": {
        "type": "string",
        "text": "Список тегов приложений.\nОбязательное.\nОписывает какие клиенты могут видеть баннер.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 1..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Градиент
   */
  "Banner.Gradient": {
    "kind": "class",
    "text": "Градиент",
    "fields": {
      /**
       * Линейный градиент
       */
      "linear": {
        "type": "Banner.Gradient.Linear",
        "text": "Линейный градиент",
      },
    },
  },
  /**
   * Линейный градиент
   */
  "Banner.Gradient.Linear": {
    "kind": "class",
    "text": "Линейный градиент",
    "fields": {
      /**
       * Угол направления линейного градиента в градусах.
       * # Диапазон: 0..360
       */
      "angle": {
        "type": "float",
        "text": "Угол направления линейного градиента в градусах.\n# Диапазон: 0..360",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 360,
            "message": "Значение не входит в допустимый диапазон. Максимум: 360"
          },
        }
      },
      /**
       * Точки градиента.
       * Обязательное.
       * # Диапазон: 2..20
       */
      "points": {
        "type": "Banner.Gradient.Linear.Point",
        "text": "Точки градиента.\nОбязательное.\n# Диапазон: 2..20",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "max": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
        }
      },
    },
  },
  /**
   * Точка
   */
  "Banner.Gradient.Linear.Point": {
    "kind": "class",
    "text": "Точка",
    "fields": {
      /**
       * Цвет линейного градиента.
       * Обязательное.
       * Отрисовывается до загрузки картинки и градиента.
       * Все цвета должны быть в формате hex #RRGGBBAA.
       * Пример: #7e00c380.
       * # Диапазон: 9..9.
       * # Паттерн: /^#[0-9a-fA-F]{8}$/
       */
      "color": {
        "type": "string",
        "text": "Цвет линейного градиента.\nОбязательное.\nОтрисовывается до загрузки картинки и градиента.\nВсе цвета должны быть в формате hex #RRGGBBAA.\nПример: #7e00c380.\n# Диапазон: 9..9.\n# Паттерн: /^#[0-9a-fA-F]{8}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Минимум: 9"
          },
          "maxLength": {
            "value": 9,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9"
          },
          "pattern": {
            "value": /^#[0-9a-fA-F]{8}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^#[0-9a-fA-F]{8}$/"
          }
        }
      },
      /**
       * Стоп линейного градиента.
       * Записывается в процентах.
       * # Диапазон: 0..100
       */
      "stop": {
        "type": "float",
        "text": "Стоп линейного градиента.\nЗаписывается в процентах.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Объект картинки
   */
  "Banner.Image": {
    "kind": "class",
    "text": "Объект картинки",
    "fields": {
      /**
       * Тип картинки.
       * Обязательное
       */
      "type": {
        "type": "Banner.Image.Type",
        "text": "Тип картинки.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ссылки на картинку.
       * Обязательное.
       * # Диапазон: 12..512
       */
      "url": {
        "type": "string",
        "text": "Значение ссылки на картинку.\nОбязательное.\n# Диапазон: 12..512",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 12,
            "message": "Значение не входит в допустимый диапазон. Минимум: 12"
          },
          "maxLength": {
            "value": 512,
            "message": "Значение не входит в допустимый диапазон. Максимум: 512"
          },
        }
      },
    },
  },
  /**
   * Ссылка
   */
  "Banner.Link": {
    "kind": "class",
    "text": "Ссылка",
    "fields": {
      /**
       * Тип платформы.
       * Обязательное
       */
      "platformType": {
        "type": "Banner.PlatformType",
        "text": "Тип платформы.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип ссылки.
       * Обязательное
       */
      "type": {
        "type": "Banner.Link.Type",
        "text": "Тип ссылки.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ссылки для перехода.
       * Обязательное.
       * # Диапазон: 12..512
       */
      "url": {
        "type": "string",
        "text": "Значение ссылки для перехода.\nОбязательное.\n# Диапазон: 12..512",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 12,
            "message": "Значение не входит в допустимый диапазон. Минимум: 12"
          },
          "maxLength": {
            "value": 512,
            "message": "Значение не входит в допустимый диапазон. Максимум: 512"
          },
        }
      },
      /**
       * Список пакетов.
       * Если пусто попытка перехода осуществляется безусловно.
       * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.
       * # Диапазон: 0..20
       */
      "packages": {
        "type": "string",
        "text": "Список пакетов.\nЕсли пусто попытка перехода осуществляется безусловно.\nЕсли заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве, иначе обработка переходит к следующей ссылке.\n# Диапазон: 0..20",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Banner.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "Banner.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "Banner.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Фильтр баннеров
   */
  "BannerFilter": {
    "kind": "class",
    "text": "Фильтр баннеров",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Название;
       * # - Заголовок;
       * # - Подзаголовок;
       * # - Список тегов пользователей;
       * # - Список тегов приложений
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Название;\n# - Заголовок;\n# - Подзаголовок;\n# - Список тегов пользователей;\n# - Список тегов приложений",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По типам баннеров
       */
      "types": {
        "type": "Banner.Type",
        "text": "По типам баннеров",
      },
      /**
       * От приоритета включительно (больше или равно)
       */
      "beginPriority": {
        "type": "google.protobuf.Int32Value",
        "text": "От приоритета включительно (больше или равно)",
      },
      /**
       * До приоритета (меньше)
       */
      "endPriority": {
        "type": "google.protobuf.Int32Value",
        "text": "До приоритета (меньше)",
      },
      /**
       * По типам приоритетов.
       * Переписывает значения фильтров по приоритету.
       * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
       */
      "priorityTypes": {
        "type": "Banner.PriorityType",
        "text": "По типам приоритетов.\nПереписывает значения фильтров по приоритету.\nЕсли переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)",
      },
      /**
       * От даты начала показа включительно (больше или равно)
       */
      "beginShowStartAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты начала показа включительно (больше или равно)",
      },
      /**
       * До даты начала показа (меньше)
       */
      "endShowStartAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты начала показа (меньше)",
      },
      /**
       * От даты конца показа включительно (больше или равно)
       */
      "beginShowEndedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты конца показа включительно (больше или равно)",
      },
      /**
       * До даты конца показа (меньше)
       */
      "endShowEndedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты конца показа (меньше)",
      },
      /**
       * По статусам баннеров.
       * Переписывает значения фильтров по датам.
       * Если переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)
       */
      "statusTypes": {
        "type": "Banner.StatusType",
        "text": "По статусам баннеров.\nПереписывает значения фильтров по датам.\nЕсли переданы все типы, то фильтр игнорируется(так как нужно вернуть всё)",
      },
      /**
       * По пользовательским тегам.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 0..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "userTags": {
        "type": "string",
        "text": "По пользовательским тегам.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 0..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
      /**
       * По тегам приложений.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 0..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "appTags": {
        "type": "string",
        "text": "По тегам приложений.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 0..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
    },
  },
  /**
   * Облегчённый баннер
   */
  "BannerLite": {
    "kind": "class",
    "text": "Облегчённый баннер",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
      },
      /**
       * Количество дней через которое можно повторно показать баннер.
       * Если Значение не указано то повторного показа баннера не будет
       */
      "repeatAfterDays": {
        "type": "google.protobuf.Int32Value",
        "text": "Количество дней через которое можно повторно показать баннер.\nЕсли Значение не указано то повторного показа баннера не будет",
      },
      /**
       * Картинки
       */
      "images": {
        "type": "BannerLite.ImageLite",
        "text": "Картинки",
      },
      /**
       * Ссылки для переходов.
       * Возвращаются отфильтрованные по платформе
       */
      "links": {
        "type": "BannerLite.LinkLite",
        "text": "Ссылки для переходов.\nВозвращаются отфильтрованные по платформе",
      },
    },
  },
  /**
   * Упрощённый объект картинки
   */
  "BannerLite.ImageLite": {
    "kind": "class",
    "text": "Упрощённый объект картинки",
    "fields": {
      /**
       * Тип картинки.
       * Обязательное
       */
      "type": {
        "type": "Banner.Image.Type",
        "text": "Тип картинки.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ссылки на картинку.
       * Обязательное
       */
      "url": {
        "type": "string",
        "text": "Значение ссылки на картинку.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Упрощённая ссылка
   */
  "BannerLite.LinkLite": {
    "kind": "class",
    "text": "Упрощённая ссылка",
    "fields": {
      /**
       * Тип ссылки.
       * Обязательное
       */
      "type": {
        "type": "Banner.Link.Type",
        "text": "Тип ссылки.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ссылки.
       * Обязательное
       */
      "url": {
        "type": "string",
        "text": "Значение ссылки.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список пакетов.
       * Если пусто попытка перехода осуществляется безусловно.
       * Если заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве иначе обработка переходит к следующей ссылке
       */
      "packages": {
        "type": "string",
        "text": "Список пакетов.\nЕсли пусто попытка перехода осуществляется безусловно.\nЕсли заполнено, то переход осуществляется только в случае если хоть один пакет есть на устройстве иначе обработка переходит к следующей ссылке",
      },
      /**
       * Тип платформы.
       * Обязательное
       */
      "platformType": {
        "type": "Banner.PlatformType",
        "text": "Тип платформы.\nОбязательное",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Упрощённый фильтр по баннерам
   */
  "BannerLiteFilter": {
    "kind": "class",
    "text": "Упрощённый фильтр по баннерам",
    "fields": {
      /**
       * По типам баннеров
       */
      "types": {
        "type": "Banner.Type",
        "text": "По типам баннеров",
      },
      /**
       * Название приложения.
       * # Диапазон: 1..19.
       * # Паттерн: /^[0-9A-Z-]{1,19}$/
       */
      "appName": {
        "type": "google.protobuf.StringValue",
        "text": "Название приложения.\n# Диапазон: 1..19.\n# Паттерн: /^[0-9A-Z-]{1,19}$/",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 19,
            "message": "Значение не входит в допустимый диапазон. Максимум: 19"
          },
          "pattern": {
            "value": /^[0-9A-Z-]{1,19}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[0-9A-Z-]{1,19}$/"
          }
        }
      },
      /**
       * Тип платформы
       */
      "platformType": {
        "type": "Banner.PlatformType",
        "text": "Тип платформы",
      },
      /**
       * Версия приложения.
       * # Диапазон: 1..19.
       * # Паттерн: /^[0-9A-Z-]{1,19}$/
       */
      "version": {
        "type": "google.protobuf.StringValue",
        "text": "Версия приложения.\n# Диапазон: 1..19.\n# Паттерн: /^[0-9A-Z-]{1,19}$/",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 19,
            "message": "Значение не входит в допустимый диапазон. Максимум: 19"
          },
          "pattern": {
            "value": /^[0-9A-Z-]{1,19}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[0-9A-Z-]{1,19}$/"
          }
        }
      },
      /**
       * По тегам пользователя.
       * Тэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.
       * # Диапазон: 1..20.
       * # Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/
       */
      "userTags": {
        "type": "string",
        "text": "По тегам пользователя.\nТэг - максимум 5 символов, значение - максимум 19 символов, количество сегментов - максимум 10.\n# Диапазон: 1..20.\n# Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
          "pattern": {
            "value": /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[A-Z-]{1,5}_[0-9A-Z-]{1,19}(?:\.[A-Z-]{1,5}_[0-9A-Z-]{1,19}){0,9}$/"
          }
        }
      },
    },
  },
  /**
   * Пагинация баннеров
   */
  "BannerPaging": {
    "kind": "class",
    "text": "Пагинация баннеров",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "BannerPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "BannerPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос получения количества баннеров
   */
  "GetBannerCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества баннеров",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "BannerFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества баннеров
   */
  "GetBannerCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества баннеров",
    "fields": {
      /**
       * Всего баннеров
       */
      "data": {
        "type": "int32",
        "text": "Всего баннеров",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBannerCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества баннеров
   */
  "GetBannerCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества баннеров",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка баннеров
   */
  "GetBannerListRequest": {
    "kind": "class",
    "text": "Запрос получения списка баннеров",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "BannerFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "BannerPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка баннеров
   */
  "GetBannerListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка баннеров",
    "fields": {
      /**
       * Баннер
       */
      "data": {
        "type": "Banner",
        "text": "Баннер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBannerListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка баннеров
   */
  "GetBannerListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка баннеров",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка упрощённого баннеров
   */
  "GetBannerLiteListRequest": {
    "kind": "class",
    "text": "Запрос получения списка упрощённого баннеров",
    "fields": {
      /**
       * Упрощённый фильтр
       */
      "filter": {
        "type": "BannerLiteFilter",
        "text": "Упрощённый фильтр",
      },
      /**
       * Признак отключения фильтрации по типу платформы
       */
      "isLinkFilterDisabled": {
        "type": "bool",
        "text": "Признак отключения фильтрации по типу платформы",
      },
    },
  },
  /**
   * Ответ на запрос получения списка упрощённых баннеров
   */
  "GetBannerLiteListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка упрощённых баннеров",
    "fields": {
      /**
       * Упрощённый баннер
       */
      "data": {
        "type": "BannerLite",
        "text": "Упрощённый баннер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBannerLiteListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка баннеров
   */
  "GetBannerLiteListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка баннеров",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения упрощённого баннера
   */
  "GetBannerLiteRequest": {
    "kind": "class",
    "text": "Запрос получения упрощённого баннера",
    "fields": {
      /**
       * Идентификатор баннера.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор баннера.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения упрощённого баннера
   */
  "GetBannerLiteResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения упрощённого баннера",
    "fields": {
      /**
       * Упрощённый баннер
       */
      "data": {
        "type": "BannerLite",
        "text": "Упрощённый баннер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBannerLiteResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения упрощённого баннера
   */
  "GetBannerLiteResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения упрощённого баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения баннера
   */
  "GetBannerRequest": {
    "kind": "class",
    "text": "Запрос получения баннера",
    "fields": {
      /**
       * Идентификатор баннера.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор баннера.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения баннера
   */
  "GetBannerResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения баннера",
    "fields": {
      /**
       * Баннер
       */
      "data": {
        "type": "Banner",
        "text": "Баннер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBannerResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения баннера
   */
  "GetBannerResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения баннера
   */
  "PostBannerRequest": {
    "kind": "class",
    "text": "Запрос сохранения баннера",
    "fields": {
      /**
       * Баннер
       */
      "data": {
        "type": "Banner",
        "text": "Баннер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения баннера
   */
  "PostBannerResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения баннера",
    "fields": {
      /**
       * Баннер
       */
      "data": {
        "type": "Banner",
        "text": "Баннер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostBannerResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения баннера
   */
  "PostBannerResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Banner.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос загрузки картинки баннера
   */
  "PostBannerUploadImageRequest": {
    "kind": "class",
    "text": "Запрос загрузки картинки баннера",
    "fields": {
      /**
       * Идентификатор баннера.
       * Используется для складывания картинок баннера в папку баннера в бакете.
       * Название картинки в папке создаётся из случайного Guid.
       * # Тип: Guid
       */
      "bannerId": {
        "type": "string",
        "text": "Идентификатор баннера.\nИспользуется для складывания картинок баннера в папку баннера в бакете.\nНазвание картинки в папке создаётся из случайного Guid.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Загружаемая картинка
       */
      "uploadImage": {
        "type": "UploadImage",
        "text": "Загружаемая картинка",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос загрузки картинки баннера
   */
  "PostBannerUploadImageResponse": {
    "kind": "class",
    "text": "Ответ на запрос загрузки картинки баннера",
    "fields": {
      /**
       * Ссылка на баннер на imageproxy cdn сервер.
       * Общедоступна в интернете
       */
      "data": {
        "type": "string",
        "text": "Ссылка на баннер на imageproxy cdn сервер.\nОбщедоступна в интернете",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostBannerUploadImageResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса загрузки картинки баннера
   */
  "PostBannerUploadImageResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса загрузки картинки баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Объект загружаемой картинки
   */
  "UploadImage": {
    "kind": "class",
    "text": "Объект загружаемой картинки",
    "fields": {
      /**
       * Картинка в формате инлайн base64.
       * Обязательное.
       * Пример: \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIA...\".
       * # Паттерн: /^data:\s*image\/(png|jpeg|jpg);\s*base64/
       */
      "base64": {
        "type": "string",
        "text": "Картинка в формате инлайн base64.\nОбязательное.\nПример: \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIA...\".\n# Паттерн: /^data:\s*image\/(png|jpeg|jpg);\s*base64/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^data:\s*image\/(png|jpeg|jpg);\s*base64/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^data:\s*image\/(png|jpeg|jpg);\s*base64/"
          }
        }
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов картинок.
   */
  "Banner.Image.Type": {
    "kind": "enum",
    "text": "Справочник типов картинок.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Пререндеренный баннер в портретном режиме.
       * В портретном режиме ширина меньше или равна высоте.
       * Представление характерно для телефонов.
       * Может содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).
       * После загрузки изображения отрисовывается поверх цвета и градиента.
       * Если ссылки нет то нужно использовать ссылку из ландшафтного режима
       */
      "PORTRAIT": {
        "i": 1,
        "text": "Пререндеренный баннер в портретном режиме.\nВ портретном режиме ширина меньше или равна высоте.\nПредставление характерно для телефонов.\nМожет содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).\nПосле загрузки изображения отрисовывается поверх цвета и градиента.\nЕсли ссылки нет то нужно использовать ссылку из ландшафтного режима",
      },
      /**
       * Пререндеренный баннер в ландшафтном режиме.
       * В ландшафтном режиме ширина больше высоты.
       * Представление характерно для планшетов и декстопа.
       * Может содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).
       * После загрузки изображения отрисовывается поверх цвета и градиента.
       * Если ссылки нет то нужно использовать ссылку из портретного режима
       */
      "LANDSCAPE": {
        "i": 2,
        "text": "Пререндеренный баннер в ландшафтном режиме.\nВ ландшафтном режиме ширина больше высоты.\nПредставление характерно для планшетов и декстопа.\nМожет содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).\nПосле загрузки изображения отрисовывается поверх цвета и градиента.\nЕсли ссылки нет то нужно использовать ссылку из портретного режима",
      },
      /**
       * Иконка.
       * Может содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).
       * После загрузки изображения отрисовывается поверх цвета и градиента
       */
      "ICON": {
        "i": 3,
        "text": "Иконка.\nМожет содержать дополнительные параметры запроса в ссылке(https://docs.imgproxy.net/generating_the_url?id=processing-options).\nПосле загрузки изображения отрисовывается поверх цвета и градиента",
      },
    },
  },
  /**
   * Справочник типов ссылок.
   */
  "Banner.Link.Type": {
    "kind": "enum",
    "text": "Справочник типов ссылок.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Ссылка для перехода на раздел текущего приложения
       */
      "INTERNAL_APP": {
        "i": 1,
        "text": "Ссылка для перехода на раздел текущего приложения",
      },
      /**
       * Ссылка для перехода на стороннее приложение
       */
      "EXTERNAL_APP": {
        "i": 2,
        "text": "Ссылка для перехода на стороннее приложение",
      },
      /**
       * Ссылка для перехода на веб-вью внутренних (своих) приложений.
       * В окне отсутствует адресаная строка.
       * Для iOS используется WKWebView, для Android используется WebView
       */
      "WEB_VIEW": {
        "i": 3,
        "text": "Ссылка для перехода на веб-вью внутренних (своих) приложений.\nВ окне отсутствует адресаная строка.\nДля iOS используется WKWebView, для Android используется WebView",
      },
      /**
       * Ссылка для перехода на веб-браузер
       */
      "WEB_BROWSER": {
        "i": 4,
        "text": "Ссылка для перехода на веб-браузер",
      },
      /**
       * Ссылка для перехода на веб-вью внешних (партнёрских) приложений.
       * В окне присутствует адресаная строка.
       * Для iOS используется SFSafariViewController, для Android используется ChromeCustomTabs
       */
      "EXTERNAL_WEB_VIEW": {
        "i": 5,
        "text": "Ссылка для перехода на веб-вью внешних (партнёрских) приложений.\nВ окне присутствует адресаная строка.\nДля iOS используется SFSafariViewController, для Android используется ChromeCustomTabs",
      },
    },
  },
  /**
   * Справочник платформ.
   */
  "Banner.PlatformType": {
    "kind": "enum",
    "text": "Справочник платформ.",
    "values": {
      /**
       * Значение не указано
       */
      "PLATFORM_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Платформа iOS.
       * Приложение размещается в App Store
       */
      "IOS": {
        "i": 1,
        "text": "Платформа iOS.\nПриложение размещается в App Store",
      },
      /**
       * Платформа Android.
       * Приложение размещается в Google Play, App Gallery или прочих сторах
       */
      "ANDROID": {
        "i": 2,
        "text": "Платформа Android.\nПриложение размещается в Google Play, App Gallery или прочих сторах",
      },
      /**
       * Платформа Web.
       * Приложение размещается по интернет адресу
       */
      "WEB": {
        "i": 3,
        "text": "Платформа Web.\nПриложение размещается по интернет адресу",
      },
    },
  },
  /**
   * Справочник типов приоритетов.
   */
  "Banner.PriorityType": {
    "kind": "enum",
    "text": "Справочник типов приоритетов.",
    "values": {
      /**
       * Значение не указано
       */
      "PRIORITY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Обычный.
       * Приоритет 31.
       * Вычисляется в логике приложения как priority меньше 64.
       * Извлекаются из базы по фильтру end_priority = 64
       */
      "NORMAL": {
        "i": 1,
        "text": "Обычный.\nПриоритет 31.\nВычисляется в логике приложения как priority меньше 64.\nИзвлекаются из базы по фильтру end_priority = 64",
      },
      /**
       * Вайт-лейбл.
       * Приоритет 127.
       * Вычисляется в логике приложения как priority больше или равно 64 и priority меньше 160.
       * Извлекаются из базы по фильтру begin_priority = 64 и end_priority = 160
       */
      "WHITE_LABEL": {
        "i": 2,
        "text": "Вайт-лейбл.\nПриоритет 127.\nВычисляется в логике приложения как priority больше или равно 64 и priority меньше 160.\nИзвлекаются из базы по фильтру begin_priority = 64 и end_priority = 160",
      },
      /**
       * Критикл.
       * Приоритет 191.
       * Вычисляется в логике приложения как priority больше или равно 160.
       * Извлекаются из базы по фильтру begin_priority = 160
       */
      "CRITICAL": {
        "i": 3,
        "text": "Критикл.\nПриоритет 191.\nВычисляется в логике приложения как priority больше или равно 160.\nИзвлекаются из базы по фильтру begin_priority = 160",
      },
    },
  },
  /**
   * Справочник статусов баннеров.
   */
  "Banner.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов баннеров.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Отложен.
       * Вычисляется в логике приложения как сurr_date меньше show_start_at.
       * Извлекаются из базы по фильтру end_show_start_at = сurr_date
       */
      "DEFERRED": {
        "i": 1,
        "text": "Отложен.\nВычисляется в логике приложения как сurr_date меньше show_start_at.\nИзвлекаются из базы по фильтру end_show_start_at = сurr_date",
      },
      /**
       * Активен.
       * Вычисляется в логике приложения как сurr_date больше или равно show_start_at и сurr_date меньше show_ended_at.
       * Извлекаются из базы по фильтру begin_show_start_at = сurr_date и end_show_ended_at = сurr_date
       */
      "ACTIVE": {
        "i": 2,
        "text": "Активен.\nВычисляется в логике приложения как сurr_date больше или равно show_start_at и сurr_date меньше show_ended_at.\nИзвлекаются из базы по фильтру begin_show_start_at = сurr_date и end_show_ended_at = сurr_date",
      },
      /**
       * Истёк.
       * Вычисляется в логике приложения как сurr_date больше или равно show_ended_at.
       * Извлекаются из базы по фильтру begin_show_ended_at = сurr_date
       */
      "EXPIRED": {
        "i": 3,
        "text": "Истёк.\nВычисляется в логике приложения как сurr_date больше или равно show_ended_at.\nИзвлекаются из базы по фильтру begin_show_ended_at = сurr_date",
      },
    },
  },
  /**
   * Справочник типов баннеров.
   */
  "Banner.Type": {
    "kind": "enum",
    "text": "Справочник типов баннеров.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Стандартный баннер
       */
      "STANDARD": {
        "i": 1,
        "text": "Стандартный баннер",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "BannerPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "BannerPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 1,
        "text": "Дата последнего изменения",
      },
      /**
       * По приоритету, затем по дате начала показа
       */
      "PRIORITY_THEN_SHOW_START_AT": {
        "i": 2,
        "text": "По приоритету, затем по дате начала показа",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 3,
        "text": "Дата создания",
      },
      /**
       * Дата начала показа
       */
      "SHOW_START_AT": {
        "i": 4,
        "text": "Дата начала показа",
      },
      /**
       * Дата конца показа
       */
      "SHOW_ENDED_AT": {
        "i": 5,
        "text": "Дата конца показа",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 6,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}